import styles from './page-title.module.less';

export interface PageTitleProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Heading level - 'h1' for page titles, 'h2' for section titles */
  level?: 'h1' | 'h2';
  className?: string;
}

export function PageTitle({ title, subtitle, level = 'h1', className }: PageTitleProps) {
  const Heading = level;

  return (
    <div className={`${styles.pageTitle} ${className || ''}`}>
      <Heading className={styles.title}>{title}</Heading>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </div>
  );
}
